// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__B6MPu","type":"styles_type__7CS39","choices":"styles_choices__HK4vm"};